import { motion } from "framer-motion";
import { Phone, MapPin, Clock } from "lucide-react";

export const AboutSection = () => {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-[#050505]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-[1px] bg-[#3b82f6]" />
              <span className="text-sm tracking-[0.3em] uppercase text-zinc-500 font-body font-medium">Who We Are</span>
            </div>
            <h2 data-testid="about-heading" className="font-heading text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tight text-white leading-[0.95] mb-10">
              Built on
              <br />
              Passion
            </h2>
            <div className="space-y-6 text-zinc-400 font-body text-base leading-relaxed">
              <p data-testid="about-text-1">
                Velocity Paint and Panel was founded by two mates with a shared obsession for automotive
                culture and the art of a perfect finish. Based at 101 Norman St, Woolloongabba, Brisbane,
                we specialise in transforming vehicles, from full colour changes to precision repairs.
              </p>
              <p data-testid="about-text-2">
                Our roots are deep in the JDM scene, but our skills extend across all makes and models.
                European, American, classic, modern. If it has panels, we can make it look incredible.
                No insurance work. No shortcuts. Just quality.
              </p>
              <p data-testid="about-text-3">
                Every job that rolls into our shop gets the same level of attention, whether it is a
                weekend project Silvia or a daily driven family car that needs some love.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="space-y-4"
          >
            <div data-testid="contact-card-blake" className="bg-[#09090b] border border-white/5 p-8 group hover:border-white/15 transition-colors">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="font-heading text-2xl uppercase tracking-wide text-white">Blake</h3>
                  <span className="text-xs tracking-[0.2em] uppercase text-zinc-600 font-body">Co-Founder</span>
                </div>
                <Phone size={18} className="text-zinc-600 group-hover:text-[#3b82f6] transition-colors" />
              </div>
              <a href="sms:0450645926" data-testid="blake-phone" className="font-mono text-xl text-white hover:text-[#3b82f6] transition-colors no-underline">
                0450 645 926
              </a>
            </div>

            <div data-testid="contact-card-harrison" className="bg-[#09090b] border border-white/5 p-8 group hover:border-white/15 transition-colors">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="font-heading text-2xl uppercase tracking-wide text-white">Harrisson</h3>
                  <span className="text-xs tracking-[0.2em] uppercase text-zinc-600 font-body">Co-Founder</span>
                </div>
                <Phone size={18} className="text-zinc-600 group-hover:text-[#3b82f6] transition-colors" />
              </div>
              <a href="sms:0421169339" data-testid="harrison-phone" className="font-mono text-xl text-white hover:text-[#3b82f6] transition-colors no-underline">
                0421 169 339
              </a>
            </div>

            <div data-testid="location-card" className="bg-[#09090b] border border-white/5 p-8 hover:border-white/15 transition-colors">
              <div className="flex items-center gap-3 mb-4">
                <MapPin size={18} className="text-[#3b82f6]" />
                <h3 className="font-heading text-xl uppercase tracking-wide text-white">Location</h3>
              </div>
              <p className="text-zinc-400 font-body text-base">101 Norman St, Woolloongabba, QLD 4102</p>
            </div>

            <div data-testid="hours-card" className="bg-[#09090b] border border-white/5 p-8 hover:border-white/15 transition-colors">
              <div className="flex items-center gap-3 mb-4">
                <Clock size={18} className="text-[#3b82f6]" />
                <h3 className="font-heading text-xl uppercase tracking-wide text-white">Hours</h3>
              </div>
              <div className="space-y-2 text-zinc-400 font-body text-sm">
                <div className="flex justify-between">
                  <span>Monday to Sunday</span>
                  <span className="text-white font-mono">9:00 AM to 5:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Availability</span>
                  <span className="text-white font-mono">By Appointment Only</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
